module.exports = __webpack_public_path__ + "static/media/bem-ireland.bf9b97b1.png";